module.exports = __webpack_public_path__ + "static/media/animation-slider-clean-touch-protect.1d6ba33.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/animation-slider-clean-touch-protect.mp4
// module id = DUBm
// module chunks = 0